import { render, staticRenderFns } from "./CellUi.vue?vue&type=template&id=0edc5498"
import script from "./CellUi.vue?vue&type=script&lang=ts"
export * from "./CellUi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports